import React from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import ContactUsForm from "../../components/contact/ContactUsForm";
import SectionWrapper from '../../components/shared/SectionWrapper';

const ContactUs = () => {
  return (
    <>
      <SEO title="Contacto" />
      <Layout>
        <div className="edu-contact-us-area">
          <SectionWrapper title="">
            <div className="col-lg-12">
              <div className="contact-info mb-5">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 text-center mb-4 mb-lg-0">
                    <div className="contact-card">
                      <div className="icon">
                        <i className="ri-mail-open-line"></i>
                      </div>
                      <h5 className="title">Correo electrónico</h5>
                      <p><a href="mailto:adocsecretaria@gmail.com">adocsecretaria@gmail.com</a></p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 text-center mb-4 mb-lg-0">
                    <div className="contact-card">
                      <div className="icon">
                        <i className="ri-phone-line"></i>
                      </div>
                      <h5 className="title">Teléfono</h5>
                      <p><a href="tel:095750717">095750717</a></p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 text-center">
                    <div className="contact-card">
                      <div className="icon">
                        <i className="ri-map-pin-line"></i>
                      </div>
                      <h5 className="title">Dirección</h5>
                      <p>Circunvalacion Cagancha 1335<br />Piso 11/ 1105</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 text-center mt-4">
                    <div className="contact-card">
                      <div className="icon">
                        <i className="ri-instagram-line"></i>
                      </div>
                      <h5 className="title">Instagram</h5>
                      <p>
                        <a href="https://www.instagram.com/adoc_italiano/" target="_blank" rel="noopener noreferrer">
                          @adoc_italiano
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="google-maps-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.9661732親!2d-56.18785!3d-34.906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f81b5ec2662f3%3A0x6f0f0c8eabad6a0e!2sCircunvalaci%C3%B3n%20Plaza%20Cagancha%201335%2C%2011100%20Montevideo%2C%20Departamento%20de%20Montevideo!5e0!3m2!1sen!2suy!4v1710901234567!5m2!1sen!2suy"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </SectionWrapper>
        </div>
      </Layout>
    </>
  );
};

export default ContactUs;
